// src/components/Shared/EducaAdd/EducaAdd.js
import React from "react";
import { Image, Button } from "semantic-ui-react";
import { BasicModal } from "../BasicModal";

export function EducaAdd({
  open,
  onClose,
  adData = {},
  size = "small",
  confirmCloseMessage = "¿Quieres cerrar este anuncio?",
}) {
  const {
    type = "image",
    src = "",
    title = "",
    description = "",
    ctaText = "",
    ctaLink = "",
  } = adData;

  const renderContent = () => {
    switch (type) {
      case "image":
        return <Image src={src} fluid />;
      case "image-text":
        return (
          <div style={{ textAlign: "center" }}>
            {src && <Image src={src} centered style={{ marginBottom: "1em" }} />}
            {title && <h3>{title}</h3>}
            {description && <p>{description}</p>}
            {ctaText && ctaLink && (
              <Button
                as="a"
                href={ctaLink}
                target="_blank"
                rel="noopener noreferrer"
                primary
                style={{ marginTop: "1em" }}
              >
                {ctaText}
              </Button>
            )}
          </div>
        );
      case "video":
        return (
          <video
            src={src}
            controls
            style={{ width: "100%", borderRadius: 4 }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <BasicModal
      show={open}
      close={onClose}
      title={title}
      size={size}
      confirmCloseMessage={confirmCloseMessage}
    >
      {renderContent()}
    </BasicModal>
  );
}
